module.exports = __webpack_public_path__ + "img/schema_oms_3a.00f67f91.svg";